import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { ArrowDown, ArrowUp, Grip } from 'lucide-react'

export default function SortableReorderControls({
  disabled = false,
  index = 0,
  count = 0,
  onMoveUp,
  onMoveDown,
  listeners,
  transition,
  className = '',
  showHandle = true,
  showArrows = true,
  handleSize = 20,
  preventLinkNavigation = false,
}) {
  const isFirst = index <= 0
  const isLast = count <= 0 ? true : index >= count - 1
  const stopNavigation = (event) => {
    if (!preventLinkNavigation) return
    event.preventDefault()
    event.stopPropagation()
  }

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-between gap-2 touch-none self-center',
        className
      )}
    >
      {showArrows && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={(event) => {
            stopNavigation(event)
            onMoveUp?.(event)
          }}
          disabled={disabled || isFirst}
          aria-label="Move up"
          title="Move up"
        >
          <ArrowUp className="h-4 w-4" />
        </Button>
      )}

      {!disabled && showHandle && (
        <Grip
          size={handleSize}
          className="cursor-grab active:cursor-grabbing"
          {...listeners}
          onClick={stopNavigation}
          style={transition ? { transition } : undefined}
          aria-label="Drag to reorder"
          title="Drag to reorder"
        />
      )}

      {showArrows && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          onClick={(event) => {
            stopNavigation(event)
            onMoveDown?.(event)
          }}
          disabled={disabled || isLast}
          aria-label="Move down"
          title="Move down"
        >
          <ArrowDown className="h-4 w-4" />
        </Button>
      )}
    </div>
  )
}
